import AdditionToSumOptimizingVisitor from "./visitors/AdditionToSumOptimizingVisitor.js";

/**
 * Take a formula node as argument and return an optimized version of
 * it. If no optimization can be done, return `node` as is.
 */
export default function optimizeFormulaNode(node) {
	return optimize({
		node,
		optimizers: [new AdditionToSumOptimizingVisitor()],
	});
}

// This function isn't supposed to be used outside of tests.
/**
 * Todo: Add JSDoc comment
 */
export function optimize({ node, optimizers }) {
	let result;
	let intermediateResult = node;

	do {
		result = intermediateResult;
		intermediateResult = optimizeOnce({ node: result, optimizers });
	} while (result !== intermediateResult);

	return result;
}

function optimizeOnce({ node, optimizers }) {
	let result = node;

	for (const optimizer of optimizers) {
		result = optimizer.optimize(result);
	}

	return result;
}
